import ReservationService from '@/services/reservation.service'

const DEFAULT_FILTERS = {
  store_id: null,
  warehouse_id: [],
  channel_id: [],
  product_id: null,
  search: '',
  sort: 'desc',
  created_date_from: '',
  created_date_to: '',
}

export default {
  namespaced: true,
  state: () => ({
    filters: { ...DEFAULT_FILTERS },
    pagination: { page: 1, limit: 10, total: 0 },
    items: [],
    stores: [],
    loading: { list: false, stores: false },
    error: null,
  }),
  mutations: {
    SET_FILTER(state, patch) {
      state.filters = { ...state.filters, ...patch }
      state.pagination.page = 1
    },
    RESET_FILTERS(state) {
      state.filters = { ...DEFAULT_FILTERS }
      state.pagination.page = 1
    },
    SET_PAGE(state, page) {
      state.pagination.page = page
    },
    SET_LIMIT(state, limit) {
      state.pagination.limit = limit
      state.pagination.page = 1
    },
    SET_ITEMS(state, { items, total }) {
      state.items = items
      state.pagination.total = total
    },
    SET_STORES(state, stores) {
      state.stores = stores
    },
    SET_LOADING(state, { key, value }) {
      state.loading = { ...state.loading, [key]: value }
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },
  actions: {
    async fetchStores({ commit }, search) {
      commit('SET_LOADING', { key: 'stores', value: true })
      try {
        const res = await ReservationService.listStores(search)
        commit('SET_STORES', (res && res.data) || [])
      } catch (e) {
        commit('SET_ERROR', e.message || 'failed to fetch stores')
      } finally {
        commit('SET_LOADING', { key: 'stores', value: false })
      }
    },
    async fetchList({ commit, state }) {
      if (!state.filters.store_id) {
        commit('SET_ITEMS', { items: [], total: 0 })
        return
      }
      commit('SET_LOADING', { key: 'list', value: true })
      commit('SET_ERROR', null)
      try {
        const res = await ReservationService.list({
          ...state.filters,
          page: state.pagination.page,
          limit: state.pagination.limit,
        })
        const payload = (res && res.data) || {}
        commit('SET_ITEMS', {
          items: payload.data || [],
          // WMS returns `total_rows`; fall back to `total` if shape ever changes.
          total: payload.total_rows != null ? payload.total_rows : (payload.total || 0),
        })
      } catch (e) {
        const code = e.response && e.response.data && e.response.data.code
        commit('SET_ERROR', code || e.message || 'failed to fetch reservations')
        commit('SET_ITEMS', { items: [], total: 0 })
      } finally {
        commit('SET_LOADING', { key: 'list', value: false })
      }
    },
    setFilter({ commit, dispatch }, patch) {
      commit('SET_FILTER', patch)
      dispatch('fetchList')
    },
    setPage({ commit, dispatch }, page) {
      commit('SET_PAGE', page)
      dispatch('fetchList')
    },
    setLimit({ commit, dispatch }, limit) {
      commit('SET_LIMIT', limit)
      dispatch('fetchList')
    },
    resetFilters({ commit }) {
      commit('RESET_FILTERS')
      commit('SET_ITEMS', { items: [], total: 0 })
    },
  },
}
